/**
 * Created by bszggg on 2020. 03. 06..
 */
const moment = require('moment');
import Helper from '@/helper/Helper';


const HelperPdf = {
  // getTemplate:()=>{},
  // setTemplate:()=>{},
  // getData:()=>{},
  // setData:()=>{},
  getPack(modul, packKey){
    let ret = "";
    Array.prototype.forEach.call(modul.packs, function (e, i) {
      if (Number(e.key) === Number(packKey)) {
        ret = e.value;
      }
    });
    return ret;
  },
  getVatCardinalityByIdVat: function (modul, id) {
    let ret = 0;
    Array.prototype.forEach.call(modul.vats, function (e, x) {
      if (Number(e.id) === Number(id)) {
        ret = e.cardinality;
      }
      e.cardinality = Number(e.cardinality);
    });
    return ret
  },


  /**
   *
   * @param modul
   * @param data
   * @returns {{content: {style: string, color: string, table: {widths: [number,number,number,number,number,number,number,number,number,number,number,number], headerRows: number, body: Array.<*>}}, styles: {header: {fontSize: number, bold: boolean, margin: [number,number,number,number]}, subheader: {fontSize: number, bold: boolean, margin: [number,number,number,number]}, tableExample: {margin: [number,number,number,number]}, tableHeader: {bold: boolean, fontSize: number, color: string}, fontn8: {bold: boolean, fontSize: number, color: string}, fontn9: {bold: boolean, fontSize: number, color: string}, fontn10: {bold: boolean, fontSize: number, color: string}}, defaultStyle: {}}}
   */

  getDocDefinition(modul, data){
    /*
     data.d=modul.invoice;
     data.d_elements=modul.invoice_elements;
     data.vats=modul.vats;
     data.packs=modul.packs;
     */
    // d.zip+', '+d.city+' '+ d.public_space+' '+d.nature_of_public_space+' '+d.house_number
    const d = data.d;
    const d_elements = data.d_elements;
    const vats = data.vats;
    const packs = data.packs;
    const type = modul.$t('pdfi.' + data.type);
    let title = type;
    if (data.type === "invoice" && data.invoicetype === "STORNO") {
      title = modul.$t('pdfi.' + "stornoinvoice");
    }
    if (data.titleKey) {
      title = modul.$t(data.titleKey);
    }
    const from_phone_def = (d.from_phone_def) ? d.from_phone_def : "";
    const from_email_def = (d.from_email_def) ? d.from_email_def : "";
    const to_phone_def = (d.to_phone_def) ? d.to_phone_def : "";
    const to_email_def = (d.to_email_def) ? d.to_email_def : "";
    let companyname = (d.from_businesspartnername) ? d.from_businesspartnername : "";
    if (data.direction && data.direction === "INBOUND") { // OUTBOUND INBOUND
      companyname = (d.to_businesspartnername) ? d.to_businesspartnername : "";
    }

    const from_taxnumbercountrygroup = (d.from_taxnumbercountrygroup) ? modul.$t('pdfi.taxnumbercountrygroup') + ' : ' + d.from_taxnumbercountrygroup + '\n' : "";
    const to_taxnumbercountrygroup = (d.to_taxnumbercountrygroup) ? modul.$t('pdfi.taxnumbercountrygroup') + ' : ' + d.to_taxnumbercountrygroup + '\n' : "";
    const shippingmodetitle = (d.shippingmode) ? modul.$t('pdfi.shippingmode') + ' : ' : "";
    const shippingmodetext = (d.shippingmode) ? modul.$t('pdfi.shippingmodes' + d.shippingmode) : "";
    const prefix = data.prefix; // Helper.getMoneyDefaultDisplayPrefix();
    const suffix = data.suffix; // Helper.getMoneyDefaultDisplaySuffix();
    let supplierseller = "";
    if (data.type === "invoice") {
      supplierseller = modul.$t('pdfi.seller');
    } else if (data.type === "deliverynote") {
      supplierseller = modul.$t('pdfi.supplier');
    }
    const dstr = {};
    dstr.from_businesspartnername = Helper.String(d.from_businesspartnername);
    dstr.to_zip = Helper.String(d.to_zip);
    dstr.to_city = Helper.String(d.to_city);
    dstr.to_public_space = Helper.String(d.to_public_space);
    dstr.to_nature_of_public_space = Helper.String(d.to_nature_of_public_space);
    dstr.to_house_number = Helper.String(d.to_house_number);
    dstr.to_bank_account = Helper.String(d.to_bank_account);
    dstr.to_taxnumber = Helper.String(d.to_taxnumber);

    dstr.to_businesspartnername = Helper.String(d.to_businesspartnername);
    dstr.from_zip = Helper.String(d.from_zip);
    dstr.from_city = Helper.String(d.from_city);
    dstr.from_public_space = Helper.String(d.from_public_space);
    dstr.from_nature_of_public_space = Helper.String(d.from_nature_of_public_space);
    dstr.from_house_number = Helper.String(d.from_house_number);
    dstr.from_bank_account = Helper.String(d.from_bank_account);
    dstr.from_taxnumber = Helper.String(d.from_taxnumber);
    const head = [
      // [

      //     {
      //         text: ' ' + companyname + '\n', // + d.from_zip + ', ' + d.from_city + ' ' + d.from_public_space + ' ' + d.from_nature_of_public_space + ' ' + d.from_house_number + '\n',
      //         style: 'fontn9',
      //         colSpan: 5,
      //         alignment: 'left',
      //         border: [false, false, false, true]
      //     }, {}, {}, {}, {},
      //     {
      //         image: 'logo',
      //         colSpan: 2,
      //         alignment: 'center',
      //         border: [false, false, false, true]
      //     },{},
      //     // {},
      //     {
      //         text: '' + from_phone_def + '\n ' + from_email_def + '\n' + d.from_zip + ', ' + d.from_city + ' ' + d.from_public_space + ' ' + d.from_nature_of_public_space + ' ' + d.from_house_number,
      //         style: 'fontn9',
      //         colSpan: 5,
      //         alignment: 'right',
      //         border: [false, false, false, true]
      //     }, {}, {}, {}, {}//, {}
      // ],
      [
        {
          image: 'logo',
          colSpan: 2,
          alignment: 'center',
          border: [false, false, false, true]
        }, {},
        {
          text: ' ' + companyname + '\n', // + d.from_zip + ', ' + d.from_city + ' ' + d.from_public_space + ' ' + d.from_nature_of_public_space + ' ' + d.from_house_number + '\n',
          style: 'fontn13',
          colSpan: 10,
          alignment: 'left',
          border: [true, false, false, true]
        }, {}, {}, {},// {}, // {},
        {
          // text: '' + from_phone_def + '\n ' + from_email_def + '\n' + d.from_zip + ', ' + d.from_city + ' ' + d.from_public_space + ' ' + d.from_nature_of_public_space + ' ' + d.from_house_number,
          // text: '',
          // style: 'fontn9',
          // colSpan: 6,
          // alignment: 'right',
          // border: [false, false, false, true]
        }, {}, {}, {}, {}, {}
      ],
      [{text: '\n ' + title + ' \n', style: 'title', colSpan: 12, alignment: 'center', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

      [
        {text: ' ' + modul.$t('pdfi.documentserialnumber') + ' ', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
        {
          text: ' ' + ((d.identifier_pre_id) ? d.identifier_pre_id : '') + '' + ((d.identifier_counter) ? d.identifier_counter : ''),
          style: 'x',
          colSpan: 6,
          alignment: 'right',
          border: [false, false, false, true]
        }, {}, {}, {}, {}, {}
      ],
      [
        {text: ' ' + supplierseller + ' ', style: 'tableHeader', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {},
        {text: ' ' + modul.$t('pdfi.customer') + ' ', style: 'tableHeader', colSpan: 6, alignment: 'left', border: [true, false, false, false]}, {}, {}, {}, {}, {}
      ],
      [
        {
          text: ' ' + dstr.from_businesspartnername + '\n' + dstr.from_zip + ', ' + dstr.from_city + ' ' + dstr.from_public_space + ' ' + dstr.from_nature_of_public_space + ' ' + dstr.from_house_number + '\n' + modul.$t('pdfi.bankaccountnumber') + ' : ' + dstr.from_bank_account + '\n' + modul.$t('pdfi.taxnumber') + ' : ' + dstr.from_taxnumber + '\n' + from_taxnumbercountrygroup,
          style: 'fontn9',
          colSpan: 6,
          alignment: 'left',
          border: [false, false, false, true]
        }, {}, {}, {}, {}, {},
        {
          text: ' ' + dstr.to_businesspartnername + '\n' + ' ' + dstr.to_zip + ', ' + dstr.to_city + ' ' + dstr.to_public_space + ' ' + dstr.to_nature_of_public_space + ' ' + dstr.to_house_number + '\n' + modul.$t('pdfi.bankaccountnumber') + ' : ' + dstr.to_bank_account + '\n' + modul.$t('pdfi.taxnumber') + ' : ' + dstr.to_taxnumber + '\n' + to_taxnumbercountrygroup,
          style: 'fontn9',
          colSpan: 6,
          alignment: 'left',
          border: [true, false, false, true]
        }, {}, {}, {}, {}, {}
      ],
      [
        {text: ' ' + ((data.type === "invoice") ? modul.$t('invoice.payment_type') + ' :\n' : ""), style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + ((d.originalinvoicenumber) ? modul.$t('invoice.originalinvoicenumber') + ' :\n' : ' \n'), style: 'fontn9', colSpan: 4, alignment: 'left', border: [false, false, false, false]}, {},
        {}, {}, // {}, {},
        {text: ' ' + modul.$t('pdfi.dt_completion') + ' :', style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + modul.$t('pdfi.dt_make') + ' :', style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + ((data.type === "invoice") ? modul.$t('pdfi.dt_paymentdeadline') + ' :' : ""), style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
      ],
      [
        {text: ((data.type === "invoice") ? modul.$t("invoice.paymenttype" + d.payment_type) : ""), style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: d.originalinvoicenumber, style: 'fontn9', colSpan: 4, alignment: 'left', border: [false, false, false, false]}, {},
        {}, {}, // {}, {},
        {text: d.dt_completion, style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: d.dt_make, style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ((data.type === "invoice") ? d.dt_paymentdeadline : ""), style: 'fontn9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
      ],
      [{text: '', style: '', colSpan: 12, alignment: 'center', border: [false, false, false, true]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

    ];
    if(data.from_store_name){
        head.push([
          {text: ' ' + modul.$t('pdfi.from_store') + ' ', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
          {
            text: ' ' + ((data.from_store_name) ? data.from_store_name : ''),
            style: 'x',
            colSpan: 6,
            alignment: 'right',
            border: [false, false, false, true]
          }, {}, {}, {}, {}, {}
        ]);
    }
    if(data.to_store_name){
        head.push([
          {text: ' ' + modul.$t('pdfi.to_store') + ' ', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
          {
            text: ' ' + ((data.to_store_name) ? data.to_store_name : ''),
            style: 'x',
            colSpan: 6,
            alignment: 'right',
            border: [false, false, false, true]
          }, {}, {}, {}, {}, {}
        ]);
    }

    const body = [];

    if (data.type === "invoice") {
      body.push([
        {text: ' ' + modul.$t('invoice.item_element_name') + ' ', style: 'fontb7', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
        // {text: ' ' +  ' ', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_vatpercent') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_pack') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_countnum') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_price_net') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_price') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_price_vat') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('invoice.item_sumprice') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]}
      ]);
    } else if (data.type === "deliverynote") {
      body.push([
        {text: ' ' + modul.$t('pdfi.denomination') + ' ', style: 'fontb7', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
        {text: ' ' + modul.$t('pdfi.storage') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.unitprice') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.quantity') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.unitofquantity') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.vat') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.net') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.gross') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]}
      ]);
    } else if (data.type === "revenue") {
      body.push([
        {text: ' ' + modul.$t('pdfi.denomination') + ' ', style: 'fontb7', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
        {text: ' ' + modul.$t('pdfi.storage') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.unitprice') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.quantity') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.unitofquantitysort') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.vat') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.net') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        {text: ' ' + modul.$t('pdfi.gross') + ' ', style: 'fontb7', colSpan: 1, alignment: 'left', border: [false, false, false, false]}
      ]);
    }

    Array.prototype.forEach.call(d_elements, function (e, x) {
      /*
       id
       id_invoice
       id_element
       item_syncpk
       item_element_name
       item_vatpercent
       item_pack
       item_key
       item_price_net
       item_price_vat
       item_price
       item_countnum
       item_sumprice
       deleted
       */
      if (data.type === "invoice") {
        let item_element_name = "";
        if (Number(e.rowtype) !== 0) {
          item_element_name = modul.$t('invoice.discount');
        }
        if (Number(e.rowtype) === 0) {
          item_element_name = e.item_element_name;
        }
        const arrRow = [
          {text: item_element_name, style: 'fontn9', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
          {text: HelperPdf.getVatCardinalityByIdVat(modul, e.item_id_vat), style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: modul.$t(HelperPdf.getPack(modul, e.item_pack)), style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: e.item_countnum, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price_net + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price_vat + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_sumprice + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]}
        ];
        body.push(arrRow);

      } else if (data.type === "deliverynote") {
        const arrRow = [
          {text: e.item_element_name, style: 'fontn9', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
          {text: 'Központi', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: '100', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: '10', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: 'Db', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: '27', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: '1000', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: '1270', style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
        ];
        body.push(arrRow);

      } else if (data.type === "revenue") {

        let item_element_name = "";
        if (Number(e.rowtype) !== 0) {
          item_element_name = modul.$t('invoice.discount');
        }
        if (Number(e.rowtype) === 0) {
          item_element_name = e.item_element_name;
        }
        const arrRow = [
          {text: item_element_name, style: 'fontn9', colSpan: 5, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
          {text: HelperPdf.getVatCardinalityByIdVat(modul, e.item_id_vat), style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: modul.$t(HelperPdf.getPack(modul, e.item_pack)), style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: e.item_countnum, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price_net + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_price_vat + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
          {text: prefix + ' ' + e.item_sumprice + ' ' + suffix, style: 'fontb8', colSpan: 1, alignment: 'left', border: [false, false, false, false]}
        ];
        body.push(arrRow);

      }

    });


    const footer = [
      [{text: '', style: '', colSpan: 12, alignment: 'center', border: [false, false, false, true]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      [
        {text: '', style: 'x', colSpan: 8, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {},
        {text: '', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: "", style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
      ],
      [
        {text: '', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {},
        {text: ' ' + modul.$t('invoice.price_sum_net') + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + modul.$t('invoice.price_vat') + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + modul.$t('invoice.price_sum') + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
      ],
      [
        {text: '', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {},
        {text: ' ' + prefix + ' ' + Helper.String(d.price_sum_net) + ' ' + suffix + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + prefix + ' ' + Helper.String(d.price_vat) + ' ' + suffix + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
        {text: ' ' + prefix + ' ' + Helper.String(d.price_sum) + ' ' + suffix + ' ', style: 'fontb9', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
      ],
      [{text: ' ', style: '', colSpan: 12, alignment: 'center', border: [false, false, false, true]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      [
        {text: ' ' + modul.$t('invoice.payable') + ' ', style: 'x', colSpan: 8, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {},
        {text: ' ' + prefix + ' ' + Helper.String(d.price_sum) + ' ' + suffix + ' ', style: 'x', colSpan: 4, alignment: 'right', border: [false, false, false, false]}, {}, {}, {}
      ],
      [{text: '', style: '', colSpan: 12, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      [{text: d.text, style: 'fontb8', colSpan: 12, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      [{text: d.text2, style: 'fontb8', colSpan: 12, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    ];
    const styles = {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10]
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      tableExample: {
        margin: [0, 5, 0, 15]
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: 'black'
      },
      title: {
        bold: true,
        fontSize: 14,
        color: 'black'
      },
      fontn7: {
        bold: false,
        fontSize: 7,
        color: 'black'
      },
      fontn8: {
        bold: false,
        fontSize: 8,
        color: 'black'
      },
      fontn9: {
        bold: false,
        fontSize: 9,
        color: 'black'
      },
      fontn10: {
        bold: false,
        fontSize: 12,
        color: 'black'
      },

      fontb7: {
        bold: true,
        fontSize: 7,
        color: 'black'
      },
      fontb8: {
        bold: true,
        fontSize: 8,
        color: 'black'
      },
      fontb9: {
        bold: true,
        fontSize: 9,
        color: 'black'
      },
      fontb10: {
        bold: true,
        fontSize: 12,
        color: 'black'
      },
      x: {
        // bold: true,
        // fontSize: 12,
        color: 'black'
      }


    };
    const defaultStyle = {
      // alignment: 'justify'
    };
    const images = {};
    if (data.logo) {
      images.logo = data.logo
      // images.logo = 'data:image/jpeg;base64,' + data.logo
    }
    const obj = {
      style: 'tableExampleX',
      color: '#444',
// 			layout: 'noBorders',
      table: {
        widths: [34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
        headerRows: 2,
        body: head.concat(body).concat(footer)
      },
    };
    const docDefinition = {
      content: obj,
      styles: styles,
      defaultStyle: defaultStyle,
      images: images,
    };
    console.log(obj);
    return docDefinition
  },

};

export default HelperPdf;
